import React from 'react';
import { Skeleton, Box, Card, CardContent, Grid } from '@mui/material';

export const TableSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => (
  <Box sx={{ width: '100%' }}>
    <Skeleton variant="rectangular" height={56} sx={{ mb: 2 }} />
    {[...Array(rows)].map((_, index) => (
      <Skeleton key={index} variant="rectangular" height={52} sx={{ mb: 1 }} />
    ))}
  </Box>
);

export const CardSkeleton: React.FC = () => (
  <Card>
    <CardContent>
      <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="text" width="40%" height={24} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="80%" height={24} />
    </CardContent>
  </Card>
);

export const DashboardStatsSkeleton: React.FC = () => (
  <Grid container spacing={3}>
    {[...Array(4)].map((_, index) => (
      <Grid item xs={12} sm={6} md={3} key={index}>
        <CardSkeleton />
      </Grid>
    ))}
  </Grid>
);

export const FormSkeleton: React.FC<{ fields?: number }> = ({ fields = 4 }) => (
  <Box sx={{ width: '100%' }}>
    {[...Array(fields)].map((_, index) => (
      <Box key={index} sx={{ mb: 3 }}>
        <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="rectangular" height={56} />
      </Box>
    ))}
    <Skeleton variant="rectangular" width="120px" height={40} sx={{ mt: 2 }} />
  </Box>
);